import React from "react";
import { Row, Col, Tabs, Tab } from "react-bootstrap";
import FontAwesome from "react-fontawesome";
import {initDeepLinkData} from "../../utilities/sdk-doc-utils";
import EntityHandler from "js/utilities/entity-handler"

export default React.createClass({

  // for updating "Array" fields, a la packageIds and domainNames
  // I like these more as a textarea with carriage returns, but for now rendering as a textfield with comma dileniation

  componentWillMount() {
    this.setState({
      value: this.props.value ? this.props.value : [],
      valueString: this.props.value ? this.props.value.join(", ") : "",
      modified: false,
      updating: false,
      successfulUpdate: false
    })
  },

  render(){

    // console.log(this.props);

    return(
      <div className="form-row">
        <label>{this.props.label}: </label>
        <span className="form-value">
          <input type="text" className="account-form-arrayfield" defaultValue={this.state.valueString} onChange={this.updateValue} disabled={!this.props.canEdit} placeholder={this.props.placeholder} />

          { this.state.modified &&
            <button onClick={this.saveUpdate} className="account-form-submit" name="Save">
              <FontAwesome className="green" name="pencil-square" title="Click to save" />
            </button>
          }

          { this.state.updating &&
            <button>
              <FontAwesome name="circle-o-notch" className="form-icon fa-spin processing" />
            </button>
          }

          { this.state.successfulUpdate &&
            <button>
              <FontAwesome name="check" className="green form-icon" />
            </button>
          }

        </span>
      </div>
    );
  },

  updateValue(e){
    var valueString = e.target.value;
    valueString = valueString.replace(/\s/g, '');
    var value = valueString.split(',');
    valueString = this.props.value ? this.props.value.join(", ") : "";
    this.setState({
      value: value,
      valueString: valueString,
      modified: true,
    });
  },

  // Not that this is a -lot- of code, but would be nice if we didn't have to duplicate this for every field type...
  // But, I don't believe there is object inheritance in React so not sure the best way to make this dry
  saveUpdate(e) {
    EntityHandler.updateEntityProperty(
      this.props.entityType,
      this.props.entityId,
      this.props.field,
      this.state.value,
      this.entityUpdated
    );

    this.setState({
      modified: false,
      updating: true
    });
  },

  entityUpdated(success){
    this.setState({
      updating: false,
      successfulUpdate: success
    });

    setTimeout(() => {
      this.setState(() => ({successfulUpdate: false}))
    }, 2000);

  },



});



// WEBPACK FOOTER //
// ./src/js/components/account/account-form-arrayfield.jsx